import { Component, Input, ElementRef } from '@angular/core';
import { SummaryTableEntry } from '../../context-discovery-services/models/summary-table-entry.model';

@Component({
  selector: 'adminapp-summary-table',
  templateUrl: './summary-table.component.html',
  styleUrls: ['./summary-table.component.scss']
})
export class SummaryTableComponent {

  shouldDisplayError: boolean;

  @Input()
  set data(entries: any) {
    const grid = this.elRef.nativeElement.querySelector('coretex-grid');
    if (!entries || entries.length === 0) {
      this.shouldDisplayError = false;
      return;
    }
    this.shouldDisplayError = true;
    grid.columns = [
      { id: 'key', label: entries.length + ' Types', isSortable: true, isResizable: true },
      { id: 'value', label: this.getTotalEntries(entries) + ' Equipment', isSortable: true, isResizable: true }];
    grid.items = entries;
  }
  constructor(private elRef: ElementRef) { }

  getTotalEntries(data: Array<SummaryTableEntry>) {
    let total = 0;
    data.forEach((entry) => {
      total += entry.value;
    });
    return total;
  }
}
